import options from './sensor-configurations.component';

export default {
    selector: 'dtSensorConfigurations',
    options
};
